import {FontSizes, FontWeights, getTheme, NeutralColors, SharedColors, Stack} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import InvoiceList from "../Lists/InvoiceList";
import PersonTransactionList from "../Lists/PersonTransactionList";

function PersonDetails(props) {
    const [user] = useContext(AuthContext);
    const [projects, setProjects] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/person/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setData(data.header); setProjects(data.transactions); setInvoices(data.invoices);})
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, refresh, user.token]);

    const theme = getTheme();
    const style = {
        root: {
            alignItems: 'middle',
            flexDirection: 'column',
            display: 'flex',
            height: 340,
            justifyContent: 'middle',
            overflow: 'hidden',
            width: 400,
            boxShadow: theme.effects.elevation8,
            borderTopWidth: 8,
            borderTopColor: SharedColors.gray10,
            borderTopStyle: 'solid',
            margin: 12
        },
    };
    return (
        <AppContent title={`${data.name} ${data.surname}`} backTo={`/person`}>
            <Stack horizontal style={{marginTop: 20}} wrap horizontalAlign='space-around'>
                <Stack.Item styles={style}>
                    <h5 style={{fontSize: FontSizes.size16, fontWeight: FontWeights.light, color: NeutralColors.gray100, height: 20, margin: 10}}>{data.account_manager}</h5>
                    <p style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light, height: 30, margin: 5}}>{data.name} {data.surname}</p>
                    <p style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light, height: 30, margin: 5}}>tel. {data.phone}</p>
                    <p style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light, height: 90, margin: 5}}>email. <a href={`mailto:${data.email}`}>{data.email}</a></p>
                    <p style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light, height: 30, margin: 5}}>{data.address}</p>
                    <p style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light, height: 30, margin: 5}}>Marketing: {data.marketing ? 'Tak' : 'Nie'}</p>
                </Stack.Item>
                <Stack.Item>
                    <PersonTransactionList data={projects} />
                </Stack.Item>
            </Stack>
            <Stack vertical>
                <InvoiceList data={invoices} project={false} refresh={() => setRefresh(refresh + 1)}/>
            </Stack>
        </AppContent>
    );
}

export default PersonDetails;